import(/* webpackMode: "eager" */ "/var/www/lumi/apps/teacher/src/app/login/page.tsx");
